module.exports = "/assets/fc351b5f226cd7718672af5bd2650a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TF.png
// module id = 1854
// module chunks = 0